/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceCategoryQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ServiceCategoryQueryOperator");
    }

    getFixupPrototypeFunction() { return ServiceCategoryQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<ServiceCategoryQueryOperator>): ServiceCategoryQueryOperator {
        let obj = Object.assign(new ServiceCategoryQueryOperator(), model);
        ServiceCategoryQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceCategoryQueryOperator>): ServiceCategoryQueryOperator {
        if (!model) return null;
        return ServiceCategoryQueryOperator.newInstance(<ServiceCategoryQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceCategoryQueryOperator) {
        if (!obj) return;

        models.ServiceCategoryQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceCategoryQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceCategoryQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Service categories to include
     */
    service_categories: Array<string>;

}
